import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { crateStockService } from '../services/apiServices';

export const CRATE_STOCKS_KEY = 'crateStocks';
export const CRATE_STOCKS_STATS_KEY = 'crateStocksStats';
export const CRATE_STOCKS_HISTORY_KEY = 'crateStocksHistory';

export function useCrateStocks(params?: any) {
  return useQuery({
    queryKey: [CRATE_STOCKS_KEY, params],
    queryFn: () => crateStockService.getAll(params),
  });
}

export function useCrateStockStats() {
  return useQuery({
    queryKey: [CRATE_STOCKS_STATS_KEY],
    queryFn: () => crateStockService.getStats(),
  });
}

export function useCreateCrateStock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => crateStockService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_KEY] });
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_STATS_KEY] });
    },
  });
}

export function useCreateCrateStockOnly() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => crateStockService.createStockOnly(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_KEY] });
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_STATS_KEY] });
    },
  });
}

export function useUpdateCrateStock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: any }) => crateStockService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_KEY] });
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_STATS_KEY] });
    },
  });
}

export function useCrateStockHistory(params?: any) {
  return useQuery({
    queryKey: [CRATE_STOCKS_HISTORY_KEY, params],
    queryFn: () => crateStockService.getHistory(params),
  });
}

export function useDeleteCrateStock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => crateStockService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_KEY] });
      queryClient.invalidateQueries({ queryKey: [CRATE_STOCKS_STATS_KEY] });
    },
  });
}
